//  * 头部组件
//  * @author tango <92853934@qq.com>
//  * @date 2018-12-004
//  * @since 1.0.0

import Vue from 'src/views/base'
import { Component, Prop, Watch } from 'vue-property-decorator'
import template from './appHeader.vue'
import { Store as ComStore } from 'src/store/modules/common'

@Component({
    name: 'appHeader',
    mixins: [template],
    components: {
    }
})
export default class AppHeader extends Vue {
    @ComStore.state('pageTitle') pageTitle
    @ComStore.state('environmentObject') environmentObject

    title = ''

    @Prop({default: true}) show
    @Prop({default: true}) showBack
    @Prop({default: -1}) backPage

    @Watch('pageTitle')
    getPageTitle(val) {
        this.title = val
    }

    @Watch('environmentObject')
    getEnvironmentObject(val) {
        this.environmentObject = val
    }

    // appHeader显示逻辑
    showTop() {
        // 右侧有显示内容：所有环境都显示
        if (this.show === 'hasRight') {
            return true
        }

        // ios的微信环境不显示
        if (this.environmentObject.isWX && this.environmentObject.isIos) {
            return false
        }

        // 独立app(安卓或苹果),非微信环境或者show!=false时显示（有搜索框的页面，show会传false过来）
        if (this.environmentObject.isApp  || !this.environmentObject.isWX || this.show) {
            return true
        }
    }

    goback() {
        this.$router.go(this.backPage)
    }

    triggerParent() {
        this.$emit('triggerFunc')
    }

    mounted () {
        // rightSlotName = '右边001'
        // rightSlot = `<span class="right-slot">${this.rightSlotName}</span>`
        // let node = document.getElementById('titleRightSlot')
        // if (node) {
        //     node.innerHTML = this.rightSlot
        // }
        // rightSlotFunc() {
        //     alert(this.rightSlotName)
        // }
    }

    created () {
        this.title = this.pageTitle
    }
}




// WEBPACK FOOTER //
// ./src/views/components/appHeader/index.js